import React, { useEffect, useState } from 'react';
import { PatientDataTable } from './PatientDataTable';
import {
	Accordion,
	AccordionItem,
	AccordionItemHeading,
	AccordionItemButton,
	AccordionItemPanel,
} from 'react-accessible-accordion';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { treatmentAdapter } from 'adapters/patients';
import { Button, Icon } from 'components';

interface TreatmentsAccordionProps {
	patientId: string | number;
	treatments: [];
}

export const TreatmentsAccordion = ({
	patientId,
	treatments,
}: TreatmentsAccordionProps) => {
	const { t } = useTranslation();

	return (
		<Accordion allowZeroExpanded>
			{treatments?.map((treatment, i) => (
				<AccordionItem
					className={cn({
						'border-grey-light border-b': i !== treatments.length - 1,
					})}
					activeClassName='opened'
					key={i}
				>
					<AccordionItemHeading>
						<AccordionItemButton
							className={cn(
								'p-6 text-orange-light flex justify-between items-center'
							)}
						>
							{`${t('treatment')} n${i + 1}`}
						</AccordionItemButton>
					</AccordionItemHeading>
					<AccordionItemPanel className='w-full border border-grey-light rounded-lg border-t-0 rounded-t-none'>
						<PatientDataTable
							className='px-6'
							data={treatmentAdapter(treatment)}
						/>
					</AccordionItemPanel>
				</AccordionItem>
			))}
		</Accordion>
	);
};
